// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectContract  {
    _originalTypeClassName = "Loom.BO.ProjectContract";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectContract.translate = translateService;
}
this.Documents = [];
this.Id = null;
this.RefName = null;
this.Type = null;
this.DateSigned = null;
this.InForce = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
RefName:any;
Type:any;
DateSigned:any;
InForce:any;
Project:any;
Documents:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeContracts(oldValue, $this);
}
Domain.Project.addContracts(value, $this);
}
}
static setDocuments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Documents == null) $this.Documents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Documents.length > 0) {
                    Domain.ProjectContract.removeDocuments($this, $this.Documents[0]);
                }

                Domain.ProjectContract.addManyDocuments($this, copyItems);
            }
static addManyDocuments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectContract.addDocuments($this, items[i]);
                }
            }
static addDocuments = ($this, item) => {
                if ($this.Documents == null) $this.Documents = [];
                if (item == null || $this.Documents.indexOf(item) > -1) return;
                $this.Documents.push(item);
if (item.ProjectContract != $this) {
Domain.Document.setProjectContract(item, $this);
}
}
static addRangeDocuments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectContract.addDocuments($this, item));
            }
static removeDocuments = ($this, item) => {
                if ($this == null || $this.Documents == null || $this.Documents.indexOf(item) === -1) return;
                var _index = $this.Documents.indexOf(item);
                $this.Documents.splice(_index, 1);
item.ProjectContract = null;
}
static clearDocuments = ($this) => { $this.Documents = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}